import { render, staticRenderFns } from "./tkdSummary.vue?vue&type=template&id=3d37e3c2&"
import script from "./tkdSummary.vue?vue&type=script&lang=js&"
export * from "./tkdSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports